module.exports = __webpack_public_path__ + "189d7730213cd55e7867c739a76b9bd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s27.jpg
// module id = 703
// module chunks = 0